<template>
  <v-row v-if="aggregatedBookings.length" class="content-5 page-break-after">
    <!-- aggregated bookings header -->
    <v-col class="col-12 py-0">
      <single-report-group-by-header :title="title" />
    </v-col>

    <!-- header -->
    <v-col class="col-12 py-0">
      <v-row class="font-weight-black">
        <!-- product -->
        <v-col class="col-4">
          {{ $t('singleReport.product') }}
        </v-col>

        <!-- people count -->
        <v-col class="col-2 text-center">
          {{ $t('singleReport.totalPeople') }}
        </v-col>

        <!-- capacity -->
        <v-col class="col-6">
          {{ $t('singleReport.maxPlaces') }}
        </v-col>
      </v-row>
    </v-col>

    <v-col class="col-12 pt-0">
      <!-- iterate grouped bookings -->
      <v-row
        v-for="(
          aggregatedBooking, aggregatedBookingIndex
        ) in aggregatedBookings"
        :key="aggregatedBookingIndex"
        class="border-top avoid-inside-break"
      >
        <!-- product -->
        <v-col class="col-4 py-1">
          {{ aggregatedBooking.getTitle() }}
        </v-col>

        <!-- people count -->
        <v-col class="col-2 py-1 text-center">
          {{ aggregatedBooking.totalPeopleCount }}
        </v-col>

        <!-- capacity -->
        <v-col
          class="col-6 py-1"
          :set="(productCapacity = aggregatedBooking.capacity)"
        >
          <!-- no capacity -->
          <span v-if="!productCapacity.hasCapacityOfAnyType()">
            {{ $t('singleReport.noLimitation') }}
          </span>

          <!-- capacity on product level -->
          <span v-else-if="productCapacity.getCapacityValues().length === 1">
            {{ productCapacity.getCapacityValues()[0].getCount() }} /
            {{ productCapacity.getCapacityValues()[0].getCapacity() }}
          </span>

          <!-- capacities on attribute level -->
          <span v-else-if="productCapacity.getCapacityValues().length > 1">
            <!-- iterate capacities -->
            <v-row
              v-for="(
                capacityValue, capacityValueIndex
              ) in productCapacity.getFilteredCapacityValues(true, false)"
              :key="capacityValueIndex"
            >
              <v-col class="col-3 py-1">
                <span class="font-weight-black"
                  >{{ capacityValue.getCount() }} /
                  {{ capacityValue.getCapacity() }}</span
                >
              </v-col>
              <v-col class="py-1">
                {{ capacityValue.getTitle() }}
              </v-col>
            </v-row>
          </span>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import SingleReportGroupByHeader from '../SingleReportGroupByHeader'
export default {
  name: 'AggregatedBookingHelper',
  components: { SingleReportGroupByHeader },
  props: {
    aggregatedBookings: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
}
</script>
